import Vue from 'vue'
import router from '@/router'
import { AppType } from '@/constants/appType'
import { getWeChatSignature } from '@/api/wechat'
import { initWXConfig, shareWeChat } from '@/libs/wechat-share'
import { enableShare, disableShare, setTitle } from '@/libs/ds-bridge'
import { ConstConfig } from '@/constants'

function callback(url) {
  const timestamp = parseInt(new Date().getTime() / 1000)
  const str = 'qwertyuiopasdfghjklzxcvbnm1234567890'
  const s = str.split('')
  let randStr = ''
  for (let i = 0; i < 7; i++) {
    randStr += s[getRandomNum(1, 36)] // 生成7位的随机签名字符串
  }
  return getWeChatSignature({
    appId: ConstConfig.wxAppId,
    url: url,
    noncestr: randStr,
    timestamp: timestamp
  })
}

/**
 * 通过当前url去请求获取签名需要的信息
 * @param url:当前的url
 * @param cb:回调函数(用于通过当前url去请求获取签名需要的信息)
 * @returns {Promise}
 */
function reqSignByUrl(url, cb) {
  const mUrl = url.split('#')[0] || window.location.href.split('#')[0]
  return new Promise(resolve => {
    resolve(cb(mUrl))
  })
}

function getRandomNum(lbound, ubound) {
  return Math.floor(Math.random() * (ubound - lbound)) + lbound
}

/** 分享链接去掉 passport：&passport=xxx / ?passport=xxx（含 hash 内 query） */
function stripPassportFromShareUrl(link) {
  if (!link || typeof link !== 'string' || link.indexOf('passport') === -1) return link
  let s = link
  s = s.replace(/&passport=[^&#]*/gi, '')
  s = s.replace(/\?passport=[^&#]*&/gi, '?')
  s = s.replace(/\?passport=[^&#]*/gi, '')
  return s
}

router.beforeEach((to, from, next) => {
  // hideMenuShare()
  disableShare()
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
    setTitle(to.meta.title)
  }
  // window.scroll(0, 0)
  next()
})

Vue.prototype.wxShare = function (shareParams) {
  if (!shareParams || typeof shareParams !== 'object') return
  const safe = {
    ...shareParams,
    link: stripPassportFromShareUrl(shareParams.link)
  }
  if (AppType.isInWeChat()) {
    // showMenuShare()
    reqSignByUrl('', callback).then(response => {
      const data = response.data
      initWXConfig(
        {
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature
        },
        false
      )
      shareWeChat(safe)
    })
  } else if (AppType.isInApp()) {
    const miniPath = '/pages/webview/main?url=' + encodeURIComponent(safe.link)
    const params = {
      title: safe.title,
      desc: safe.abstract,
      link: safe.link,
      imgUrl: safe.image
    }
    if (miniPath) {
      params.miniPath = miniPath
    }
    enableShare(params)
  } else if (window.__wxjs_environment === 'miniprogram' || (window.wx && window.wx.miniProgram)) {
    // 小程序webview环境
    // 通过postMessage发送分享数据给小程序
    window.wx.miniProgram.postMessage({
      data: {
        type: 'setShareData',
        shareData: {
          title: safe.title,
          desc: safe.abstract,
          imageUrl: safe.image,
          path: '/pages/webview/index?redirect=' + encodeURIComponent(safe.link)
        }
      }
    });
  }
}